import columns from '../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export function getDetailsTabNavOptions(rowInfo) {
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.PREDES_COMPLIANCE_INCORRECT_LOCATION_CODE_USAGE_DETAILS.id,
    mainReportId: ReportDefinitions.PREDES_COMPLIANCE_INCORRECT_LOCATION_CODE_USAGE_SUMMARY.id,
    requestParams: {
      startDate: rowInfo.row['despatchCloseDate'], // eslint-disable-line
      operatorFrom: rowInfo.row.operator,
      location: rowInfo.row.location,
      locationCodeList: rowInfo.row.locationCodeList,
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {};
}

export default (data) => {
  const {
    TextColumn,
    NonZeroTextColumn,
    DateColumn,
    NonZeroNumberColumn,
    NavigationColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Operator', 'operator'),
        new DateColumn('Despatch closed', 'despatchCloseDate')
          .withWidth(150),
        new NonZeroNumberColumn('Location code list', 'locationCodeList'),
        new TextColumn('Location', 'location'),
        new NonZeroTextColumn('No IATA', 'noIata'),
        new TextColumn('Type', 'type'),
        new NavigationColumn(new NonZeroNumberColumn('Despatches', 'despatches'), getDetailsTabNavOptions),
      ],
    },
  ];
};
